(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-page"]) return;
  try {
    
  (() => {
    const ordinal = (number) => {
      const remainder100 = number % 100;
      if (remainder100 >= 11 && remainder100 <= 13) return `${number}th`;
      if (number % 10 === 1) return `${number}st`;
      if (number % 10 === 2) return `${number}nd`;
      if (number % 10 === 3) return `${number}rd`;
      return `${number}th`;
    };

    const isMilestone = (years) => years % 10 === 0 || years === 25 || years === 75;

    const initialise = (element) => {
      if (element.dataset.initialised === 'true') return;
      element.dataset.initialised = 'true';
      const originYear = Number(element.dataset.originYear);
      const month = Number(element.dataset.eventMonth);
      const day = Number(element.dataset.eventDay);
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      let anniversaryYear = today.getFullYear();
      let anniversaryDate = new Date(anniversaryYear, month - 1, day);
      if (anniversaryDate < today) {
        anniversaryYear += 1;
        anniversaryDate = new Date(anniversaryYear, month - 1, day);
      }
      const years = anniversaryYear - originYear;
      if (years <= 0) {
        element.hidden = true;
        return;
      }
      const date = new Intl.DateTimeFormat('en-AU', { day: 'numeric', month: 'long', year: 'numeric' }).format(anniversaryDate);
      const message = (element.dataset.messageTemplate || '__DATE__ marks the __ORDINAL__ anniversary, __YEARS__ years since the event in __ORIGIN_YEAR__.')
        .replace('__DATE__', date)
        .replace('__ORDINAL__', ordinal(years))
        .replace('__YEARS__', years)
        .replace('__ORIGIN_YEAR__', originYear);
      element.querySelector('.event-anniversary__message').textContent = message;
      element.classList.toggle('event-anniversary--milestone', isMilestone(years) && element.dataset.remembrance !== 'true');
    };

    const initialiseAll = (root = document) => root.querySelectorAll('[data-event-anniversary]').forEach(initialise);
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initialiseAll());
    } else {
      initialiseAll();
    }
    document.addEventListener('shopify:section:load', (event) => initialiseAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rolling-key-dates"] && !Shopify.designMode) return;
  try {
    


(() => {
  const dayNumber = date => Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()) / 86400000;
  const storeToday = () => {
    const parts = new Intl.DateTimeFormat('en-AU', {timeZone:'Australia/Sydney',year:'numeric',month:'numeric',day:'numeric'}).formatToParts(new Date());
    const get = type => Number(parts.find(p=>p.type===type).value);
    return new Date(get('year'),get('month')-1,get('day'));
  };
  const dateFor = (event,year) => {
    if(event.rule==='nth_weekday'){
      const first = new Date(year,event.month-1,1);
      return new Date(year,event.month-1,1+(event.weekday-first.getDay()+7)%7+(event.occurrence-1)*7);
    }
    return new Date(year,event.month-1,event.day);
  };
  const occurrenceForYear = (event,year,today) => {
    if(event.rule==='one_time'&&year!==event.year)return null;
    if(event.originalYear>0&&year<event.originalYear)return null;
    const start=dateFor(event,year),end=new Date(start);
    end.setDate(end.getDate()+event.duration-1);
    return {start,end,active:dayNumber(start)<=dayNumber(today)&&dayNumber(end)>=dayNumber(today)};
  };
  const groupsForYear = (events,year,today) => {
    const byDate=new Map();
    events.forEach(event=>{
      const occurrence=occurrenceForYear(event,year,today);
      if(!occurrence)return;
      const key=String(dayNumber(occurrence.start));
      if(!byDate.has(key))byDate.set(key,{start:occurrence.start,end:occurrence.end,active:false,events:[]});
      const group=byDate.get(key);
      group.active=group.active||occurrence.active;
      if(occurrence.end>group.end)group.end=occurrence.end;
      group.events.push({...event,occurrence});
    });
    byDate.forEach(group=>group.events.sort((a,b)=>(a.originalYear||0)-(b.originalYear||0)));
    return [...byDate.values()].sort((a,b)=>a.start-b.start);
  };
  const ordinal = n => n%100>=11&&n%100<=13 ? n+'th' : n+(n%10===1?'st':n%10===2?'nd':n%10===3?'rd':'th');
  const initialise = section => {
    if(section.dataset.initialised==='true')return;
    section.dataset.initialised='true';
    const labels=section.dataset,today=storeToday(),track=section.querySelector('.rolling-key-dates__track');
    const sourceCards=[...track.querySelectorAll('.rolling-key-dates__card')];
    const events=[];
    sourceCards.forEach(card=>{
      const d=card.dataset;
      const common={rule:d.rule,year:Number(d.year),month:Number(d.month),day:Number(d.day),weekday:Number(d.weekday),occurrence:Number(d.occurrence),duration:Math.max(1,Number(d.duration)||1)};
      events.push({...common,title:card.querySelector('.rolling-key-dates__title').textContent.trim(),summary:card.querySelector('.rolling-key-dates__summary')?.textContent.trim()||'',url:card.querySelector('a.rolling-key-dates__card-link')?.getAttribute('href')||'',originalYear:Number(d.originalYear),sensitive:d.sensitive==='true',editor:card.getAttribute('data-shopify-editor-block')});
      [1,2,3].forEach(n=>{
        const month=Number(d['related'+n+'Month']),day=Number(d['related'+n+'Day']);
        const calendar=month>0&&day>0?{...common,rule:'annual',month,day,duration:1}:common;
        if(d['related'+n+'Title'])events.push({...calendar,title:d['related'+n+'Title'],summary:d['related'+n+'Summary']||'',url:d['related'+n+'Url']||'',originalYear:Number(d['related'+n+'Year']),sensitive:d['related'+n+'Sensitive']==='true'});
      });
    });
    let firstYear=today.getFullYear()-1,lastYear=today.getFullYear()+1;
    const groups=[];
    for(let year=firstYear;year<=lastYear;year++)groups.push(...groupsForYear(events,year,today));
    const make=(tag,className,text)=>{
      const el=document.createElement(tag);
      if(className)el.className=className;
      if(text!==undefined)el.textContent=text;
      return el;
    };
    const dateText=date=>new Intl.DateTimeFormat('en-AU',{day:'numeric',month:'long',year:'numeric'}).format(date);
    const monthText=date=>new Intl.DateTimeFormat('en-AU',{month:'short'}).format(date);
    const isoDate=date=>[date.getFullYear(),String(date.getMonth()+1).padStart(2,'0'),String(date.getDate()).padStart(2,'0')].join('-');
    const yearsFor=event=>event.originalYear>0?event.occurrence.start.getFullYear()-event.originalYear:0;
    const specialAnniversary=event=>{
      const years=yearsFor(event);
      return !event.sensitive&&years>0&&(years%10===0||years===25||years===75);
    };
    const anniversaryFor=event=>{
      const years=yearsFor(event);
      if(years<=0)return '';
      return event.sensitive?years+' years on':(labels.anniversaryLabel||'__ORDINAL__ anniversary').replace('__ORDINAL__',ordinal(years));
    };
    const eventTitle=event=>{
      const years=yearsFor(event);
      return years>0&&/^anniversary\b/i.test(event.title)?event.title.replace(/^anniversary\b/i,ordinal(years)+' anniversary'):event.title;
    };
    const bannerEventPhrase=event=>{
      const years=yearsFor(event);
      if(event.sensitive)return years>0?years+' years on from a sensitive event':'a sensitive event';
      if(years<=0)return event.title;
      if(/^anniversary\b/i.test(event.title)){
        const title=eventTitle(event);
        return 'the '+title.charAt(0).toLowerCase()+title.slice(1);
      }
      if(/remembrance/i.test(event.title))return years+' years since '+event.title.replace(/\s*[-—:]?\s*remembrance\b/i,'').trim();
      const title=event.title.replace(/\s*[-—:]?\s*anniversary\s*$/i,'').trim();
      return 'the '+ordinal(years)+' anniversary of '+title;
    };
    const bannerEventList=events=>{
      const phrases=events.map(bannerEventPhrase);
      if(phrases.length<2)return phrases[0]||'';
      return phrases.length===2?phrases.join(' and '):phrases.slice(0,-1).join(', ')+', and '+phrases[phrases.length-1];
    };
    const sensitiveGate=(content,group,featured)=>{
      const compact=!featured||group.events.length>1;
      const details=make('details','sensitive-event'+(compact?' sensitive-event--compact':''));
      const summary=make('summary','sensitive-event__cover');
      const closed=make('span','sensitive-event__closed');
      const warning=make('span','sensitive-event__warning');
      const icon=make('span','sensitive-event__warning-icon','!');
      icon.setAttribute('aria-hidden','true');
      warning.append(icon);
      if(!compact)warning.append(make('span','sensitive-event__warning-label','Sensitive content'));
      closed.append(warning);

      const days=dayNumber(group.start)-dayNumber(today);
      const heading=featured&&!compact?(group.active?labels.sensitiveToday:days===1?labels.sensitiveTomorrow:labels.sensitiveUpcoming):labels.sensitiveTitle;
      closed.append(make(featured&&!compact?'h2':'strong','sensitive-event__heading',heading||'Sensitive anniversary'));
      if(!compact)closed.append(make('span','sensitive-event__note',labels.sensitiveNote));
      closed.append(make('span','sensitive-event__action',labels.sensitiveView));
      summary.append(closed,make('span','sensitive-event__opened',labels.sensitiveHide));
      const body=make('div','sensitive-event__body');body.append(content);details.append(summary,body);
      return details;
    };
    const eventRow=(event,group,featured)=>{
      const row=make('div',featured?'key-date-group__feature-row':'key-date-group__row');
      const link=make(event.url?'a':'div',featured?'key-date-group__feature-link':'key-date-group__event-link');
      if(event.url){link.setAttribute('href',event.url);link.setAttribute('aria-label',event.title);link.setAttribute('title',event.title);}
      const heading=make('h3',featured?'key-date-group__feature-title':'rolling-key-dates__title',featured?eventTitle(event):event.title);
      link.append(heading);
      const anniversary=anniversaryFor(event);
      if(specialAnniversary(event)){
        link.append(make('span','key-date-group__anniversary key-date-group__anniversary--special',featured?'Special anniversary':'Special anniversary · '+yearsFor(event)+' years'));
      }else if(anniversary&&(!featured||!/^anniversary\b/i.test(event.title))){
        link.append(make('span','key-date-group__anniversary',anniversary));
      }
      if(!featured&&group.active&&!event.occurrence.active)link.append(make('span','key-date-group__anniversary',labels.yesterdayLabel||'Yesterday'));
      if(!featured&&group.events.length===1&&event.summary)link.append(make('p','key-date-group__card-summary',event.summary));
      if(featured&&event.summary)link.append(make('p','key-date-group__feature-summary',event.summary));
      if(featured)link.append(make('span','key-date-group__read',labels.todayLinkLabel||'Read about this day'));
      row.append(event.sensitive?sensitiveGate(link,group,featured):link);
      return row;
    };
    const statusFor=group=>{
      const days=dayNumber(group.start)-dayNumber(today);
      if(group.active)return days===0?(labels.todayLabel||'Today'):(labels.inProgressLabel||'Happening now');
      if(dayNumber(group.end)===dayNumber(today)-1)return labels.yesterdayLabel||'Yesterday';
      if(days===1)return labels.tomorrowLabel||'Tomorrow';
      return days<0?Math.abs(days)+' days ago':days+' '+(labels.daysLabel||'days away');
    };

    const dialog=make('dialog','key-date-dialog');
    const dialogPanel=make('div','key-date-dialog__panel');
    const dialogHeader=make('div','key-date-dialog__header');
    const dialogTitle=make('h2','key-date-dialog__title');
    dialogTitle.id='KeyDateDialogTitle-'+labels.sectionId;
    dialog.setAttribute('aria-labelledby',dialogTitle.id);
    const dialogClose=make('button','key-date-dialog__close','Close');
    dialogClose.type='button';
    dialogClose.setAttribute('aria-label','Close significant dates');
    dialogClose.autofocus=true;
    dialogClose.addEventListener('click',()=>dialog.close());
    const dialogList=make('div','key-date-dialog__list');
    dialogHeader.append(dialogTitle,dialogClose);
    dialogPanel.append(dialogHeader,dialogList);
    dialog.append(dialogPanel);
    section.append(dialog);
    dialog.addEventListener('click',event=>{
      if(event.target!==dialog)return;
      const rect=dialog.getBoundingClientRect();
      if(event.clientX<rect.left||event.clientX>rect.right||event.clientY<rect.top||event.clientY>rect.bottom)dialog.close();
    });
    const sensitiveBadge=text=>{
      const badge=make('span','key-date-summary__badge key-date-summary__badge--sensitive');
      const icon=make('span','sensitive-event__warning-icon','!');
      icon.setAttribute('aria-hidden','true');
      badge.append(icon,make('span','key-date-summary__sensitive-label',text));
      return badge;
    };
    const groupBadges=group=>{
      const badges=make('div','key-date-summary__badges');
      const sensitive=group.events.filter(event=>event.sensitive).length;
      const special=group.events.filter(specialAnniversary).length;
      if(sensitive)badges.append(sensitiveBadge(sensitive+' sensitive '+(sensitive===1?'event':'events')));
      if(special)badges.append(make('span','key-date-summary__badge key-date-summary__badge--special',special+' special '+(special===1?'anniversary':'anniversaries')));
      return badges;
    };
    const openDay=group=>{
      dialogTitle.textContent=group.events.length+' significant dates · '+dateText(group.start);
      dialogList.replaceChildren(...group.events.map(event=>{
        const item=make('article','key-date-dialog__event');
        if(event.sensitive)item.append(sensitiveBadge('Sensitive content'));
        item.append(eventRow(event,group,true));
        return item;
      }));
      dialog.showModal();
      dialog.scrollTop=0;
    };
    const summaryCard=(group,featured)=>{
      const summary=make('div','key-date-summary');
      if(!featured)summary.append(make('h3','key-date-summary__title',group.events.length+' significant dates on this day'));
      summary.append(groupBadges(group));
      const button=make('button','key-date-summary__button','View all '+group.events.length+' dates');
      button.type='button';
      button.setAttribute('aria-haspopup','dialog');
      button.setAttribute('aria-label','View all '+group.events.length+' significant dates for '+dateText(group.start));
      button.addEventListener('click',()=>openDay(group));
      summary.append(button);
      return summary;
    };

    const makeCard=group=>{
      const card=make('article','rolling-key-dates__card key-date-group');
      card.setAttribute('role','listitem');card.dataset.sensitive=String(group.events.some(e=>e.sensitive));card.dataset.eventCount=String(group.events.length);card.dataset.date=isoDate(group.start);
      if(group.events[0].editor)card.setAttribute('data-shopify-editor-block',group.events[0].editor);
      const rail=make('time','rolling-key-dates__date sensitive-event__date-bar');rail.dateTime=isoDate(group.start);rail.setAttribute('aria-label',dateText(group.start));
      rail.append(make('span','rolling-key-dates__month',monthText(group.start)),make('span','rolling-key-dates__day',String(group.start.getDate())),make('span','rolling-key-dates__year',String(group.start.getFullYear())));
      const body=make('div','key-date-group__content');
      const status=make('div','key-date-group__status-row');
      status.append(make('span','key-date-group__status',statusFor(group)));
      if(group.events.length>1)status.append(make('span','key-date-group__count',group.events.length+' events'));
      body.append(status);
      if(group.events.length>3){
        body.append(summaryCard(group,false));
      }else{
        body.style.setProperty('--date-visible-events',group.events.length);
        const rows=make('div','key-date-group__events');
        rows.append(...group.events.map(event=>eventRow(event,group,false)));
        body.append(rows);
      }
      card.append(rail,body);group.card=card;return card;
    };
    track.replaceChildren(...groups.map(makeCard));
    const banner=section.querySelector('.key-date-today'),bannerEvents=banner.querySelector('.key-date-today__events');
    const planningIntro=section.querySelector('.rolling-key-dates__header');
    if(planningIntro){
      planningIntro.classList.add('key-date-calendar-intro');
      banner.querySelector('.key-date-today__inner').prepend(planningIntro);
    }

    const active=groups.filter(g=>g.active),next=groups.find(g=>dayNumber(g.start)>dayNumber(today));
    const featured=active.length?active.map(group=>({...group,events:group.events.filter(event=>event.occurrence.active)})):next?[next]:[];
    bannerEvents.replaceChildren();
    featured.forEach(group=>{
      group.card.classList.add('rolling-key-dates__card--featured');
      const block=make('div','key-date-today__event key-date-group__feature');
      block.dataset.eventCount=String(group.events.length);block.dataset.date=isoDate(group.start);
      const days=dayNumber(group.start)-dayNumber(today);
      if(group.events.length===1){
        const event=group.events[0];
        const content=make('div','key-date-group__single-feature');
        const lead=group.active?(labels.todayIntroLabel||'Today is'):days===1?(labels.tomorrowIntroLabel||'Tomorrow is'):(labels.countdownTemplate||'__DAYS__ days until').replace('__DAYS__',days);
        const title=eventTitle(event);
        const sentence=/^anniversary\b/i.test(event.title)?'the '+title.charAt(0).toLowerCase()+title.slice(1):title;
        content.append(make('h2','key-date-today__title',lead+' '+sentence));
        if(specialAnniversary(event))content.append(make('span','key-date-group__anniversary key-date-group__anniversary--special','Special anniversary · '+yearsFor(event)+' years'));

        if(event.summary)content.append(make('p','key-date-today__summary',event.summary));
        if(event.url){
          const a=make('a','key-date-today__cta',(labels.todayLinkLabel||'Read about this day'));a.setAttribute('href',event.url);content.append(a);
        }
        block.append(event.sensitive?sensitiveGate(content,group,true):content);
      }else{
        const lead=group.active?(days===0?'Today marks ':'Happening now: '):days===1?'Tomorrow marks ':days+' days until ';
        block.append(make('h2','key-date-today__title',lead+bannerEventList(group.events)));
        // Individual events remain available in the carousel below.
      }
      bannerEvents.append(block);
    });
    banner.hidden=featured.length===0;
    const main=section.closest('main');
    if(main)main.prepend(banner);
    section.querySelector('.rolling-key-dates__empty').hidden=groups.length>0;
    const previous=section.querySelector('.rolling-key-dates__control--previous'),nextButton=section.querySelector('.rolling-key-dates__control--next');
    previous.disabled=nextButton.disabled=groups.length<2;
    if(main&&featured.length){
      const wrapper=section.closest('.shopify-section');section.classList.add('rolling-key-dates--featured');banner.querySelector('.key-date-today__inner').append(section);if(wrapper)wrapper.hidden=true;
    }
    if(groups.length>1){
      let timer,scrollFrame,positioning=false;
      track.style.overflowAnchor='none';
      const jump=left=>{const behavior=track.style.scrollBehavior;track.style.scrollBehavior='auto';track.scrollLeft=left;track.style.scrollBehavior=behavior;};
      const bounds=()=>{
        const step=groups[0].card.getBoundingClientRect().width+(parseFloat(getComputedStyle(track).columnGap)||0);
        const maximum=Math.max(0,track.scrollWidth-track.clientWidth);
        previous.disabled=nextButton.disabled=maximum<=1;
        return {step,maximum};
      };
      const extend=direction=>{
        const year=direction<0?--firstYear:++lastYear;
        const extra=groupsForYear(events,year,today);
        const cards=extra.map(makeCard);
        if(direction<0){
          const left=track.scrollLeft,{step}=bounds();
          groups.unshift(...extra);
          track.prepend(...cards);
          jump(left+extra.length*step);
        }else{
          groups.push(...extra);
          track.append(...cards);
        }
      };
      const centre=()=>{
        const {step,maximum}=bounds();
        const index=groups.findIndex(group=>group.card===featured[0]?.card);
        jump(Math.min(maximum,step*Math.max(0,index)));
      };
      const move=direction=>{
        positioning=true;
        let {step,maximum}=bounds();
        if(maximum<=1){positioning=false;return;}
        if(direction<0&&track.scrollLeft<=step*2)extend(-1);
        if(direction>0&&track.scrollLeft>=maximum-step*2)extend(1);
        ({step,maximum}=bounds());
        jump(Math.max(0,Math.min(maximum,track.scrollLeft+direction*step)));
        positioning=false;
      };
      previous.addEventListener('click',()=>move(-1));
      nextButton.addEventListener('click',()=>move(1));
      track.addEventListener('scroll',()=>{
        if(positioning||scrollFrame)return;
        scrollFrame=requestAnimationFrame(()=>{
          scrollFrame=0;
          if(positioning)return;
          const {step,maximum}=bounds();
          if(maximum<=1)return;
          positioning=true;
          if(track.scrollLeft<=step*2)extend(-1);
          else if(track.scrollLeft>=maximum-step*2)extend(1);
          positioning=false;
        });
      },{passive:true});
      window.addEventListener('resize',()=>{clearTimeout(timer);timer=setTimeout(()=>bounds(),120);});
      requestAnimationFrame(centre);
    }
    if(active.length&&!featured.some(g=>g.events.some(e=>e.sensitive))&&!window.matchMedia('(prefers-reduced-motion: reduce)').matches){
      const highlight=banner.querySelector('.key-date-today__inner');let started=false,finished=false,inView=false;
      const update=()=>{const visible=inView&&!document.hidden;if(visible&&!started){started=true;setTimeout(()=>{finished=true;highlight.classList.remove('is-pulsing');},10000);}highlight.classList.toggle('is-pulsing',visible&&!finished);};
      if('IntersectionObserver' in window){const observer=new IntersectionObserver(([entry])=>{inView=entry.isIntersecting;update();});observer.observe(banner);}else{inView=true;update();}
      document.addEventListener('visibilitychange',update);
    }
  };
  const all=(root=document)=>root.querySelectorAll('.rolling-key-dates[data-section-id]').forEach(initialise);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>all());else all();
  document.addEventListener('shopify:section:load',event=>all(event.target));
})();



  } catch(e) { console.error(e); }
})();
})();
